import {html, type TemplateResult} from "lit";
import {customElement, property} from "lit/decorators.js";
import {UnLitElement} from "./elements";

@customElement("eop-tab-out-listener")
export class EopTabOutListener extends UnLitElement {

    @property()
    public callback: () => void;

    public render(): TemplateResult {
        return html`
            <div tabindex="0" @focusin=${this.onTabOut} class="tab-out-button" aria-label="Tab-Out-Element"></div>
        `;
    }

    private onTabOut(e: Event): void {
        e.preventDefault();
        e.stopPropagation();
        this.callback();
    }
}